export default __webpack_public_path__ + "static/media/f2.10dd9b25.svg";